import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Product from "@/components/Product";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-white text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100">
      <SEO
        title="Govern AI. Master Compliance."
        description="Jaisphere — Enterprise AI Inventory & Compliance Governance plus cloud-native engineering, VMware exits, and GenAI agents for the Fortune 100. Founded 2008 · Atlanta, GA."
        path="/"
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Product />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
